var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeslikeAtivo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    className: "Hawkins-Icon Hawkins-Icon-Standard",
    "data-name": "RateDownFill",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m10.593 17.744.094.752A2.859 2.859 0 0 0 13.524 21a.476.476 0 0 0 .476-.476v-3.237a1 1 0 0 1 .152-.53l1.94-3.105a2 2 0 0 1 1.147-.863l2.036-.582a1 1 0 0 0 .725-.961V5.684A.684.684 0 0 0 19.316 5c-1.19 0-2.36-.31-3.393-.901L15.75 4a7.59 7.59 0 0 0-3.766-1H7.5a1.5 1.5 0 0 0-1.118 2.5H6a1.5 1.5 0 0 0-.787 2.777A1.5 1.5 0 0 0 5.5 11.25h.17A1.499 1.499 0 0 0 6.5 14h4.375l-.282 2.256a5.998 5.998 0 0 0 0 1.488Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeslikeAtivo);
export default __webpack_public_path__ + "static/media/deslike-ativo.ef7b0f9ac12dfdf8d96f7a671f93f1ad.svg";
export { ForwardRef as ReactComponent };